const COMMENT_ACTION_SELECTOR = '[data-testid^="reply-actions-"]';

function updateControl(control) {
  const menuButton = control.querySelector('[data-testid^="reply-menu-"]');
  if (menuButton) menuButton.setAttribute('aria-label', 'Azioni commento');

  const deleteButton = control.querySelector('[data-testid^="delete-reply-"]');
  if (deleteButton && deleteButton.textContent !== 'Elimina') {
    deleteButton.textContent = 'Elimina';
  }

  const confirmation = control.querySelector('.ol-reply-confirm-box p');
  if (confirmation) {
    confirmation.textContent = 'Eliminare definitivamente questo commento?';
  }

  const error = control.querySelector('.ol-reply-delete-error');
  if (error?.textContent === 'Impossibile eliminare la risposta') {
    error.textContent = 'Impossibile eliminare il commento';
  }
}

export function decorateCommentDeleteLabels(root = document) {
  const controls = root.querySelectorAll?.(COMMENT_ACTION_SELECTOR) || [];
  Array.from(controls).forEach(updateControl);
}

export function startCommentDeleteLabels() {
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
    return () => {};
  }

  let timer = null;
  const schedule = () => {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      timer = null;
      decorateCommentDeleteLabels(document);
    }, 60);
  };

  schedule();
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });

  return () => {
    if (timer) window.clearTimeout(timer);
    observer.disconnect();
  };
}
